import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { DemandsTableComponent } from '../../../../shared/components/demands-table/demands-table.component';

@Component({
  selector: 'app-demands',
  standalone: true,
  imports: [RouterLink, DemandsTableComponent],
  templateUrl: './demands.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './demands.component.scss',
})
export class DemandsComponent {
  private readonly route = inject(ActivatedRoute);
  readonly pageTitle =
    typeof this.route.snapshot.data['pageTitle'] === 'string'
      ? this.route.snapshot.data['pageTitle']
      : 'My Demands';
}